<ng-container *ngIf="initialized">

    <ng-container *ngIf="historyList.length">
        <div class="col-12 flex flex-column row-gap-3 px-3 mb-6 py-0">

            @for (item of historyList; track item.id) {
                <ng-container
                        *ngIf="item['uiType'] == 'comment' && (selectedAction == enumCommentHistory['All Activity'] || selectedAction == enumCommentHistory.Comment)">

                    <!--                                        <div class="flex">-->

                    <!--                                            <mvs-form-control-output-user-image [value]="item['createdBy']"-->
                    <!--                                                                                [displayInfo]="true">-->
                    <!--                                            </mvs-form-control-output-user-image>-->

                    <div [id]="'comment-' + item.id" (contextmenu)="prepareContextMenu($event, item)" class="w-full"
                         (mouseenter)="onCommentHover(item.id)" (mouseleave)="onCommentHover(null)"
                         [ngClass]="item['euVisible'] ? 'hover:surface-100 border-round p-1' : ''">
                        <div class="grid mx-0">
                                <span class="block text-900 col-6">
                                     <mvs-form-control-output-user-image [value]="item['createdBy']"
                                                                         [displayInfo]="true">
                                     </mvs-form-control-output-user-image>
                                </span>
                            <div class="col-6 align-self-center">
                                <div class="flex gap-2 align-items-center justify-content-end">
                                    <div class="inline-flex align-items-center gap-1 transition-duration-200"
                                         [style.opacity]="hoveredCommentId === item.id ? 1 : 0"
                                         [style.visibility]="hoveredCommentId === item.id ? 'visible' : 'hidden'">
                                        <p-button *ngIf="canEditComment(item)"
                                                  icon="fa-regular fa-pen-to-square"
                                                  [pTooltip]="getRemainingEditTime(item)"
                                                  (onClick)="startEdit(item)"
                                                  styleClass="p-button-text p-button-sm p-button-rounded"></p-button>
                                        <p-button *ngIf="canEditComment(item)"
                                                  icon="fa-regular fa-trash text-red-500"
                                                  (onClick)="handleDeleteComment(item)"
                                                  styleClass="p-button-text p-button-sm p-button-rounded"></p-button>
                                        <p-button icon="fa-regular fa-copy"
                                                  (onClick)="copyToClipboard(item)"
                                                  styleClass="p-button-text p-button-sm p-button-rounded"></p-button>
                                    </div>
                                    <div class="flex align-items-center gap-2" *ngIf="item['euVisible']">
                                        <p-tag class="w-max" icon="pi pi-check-circle" value="Eu visible"
                                               styleClass="border-round"
                                               [style]="{background: 'var(--green-100)' , color: 'var(--green-700)'}"></p-tag>
                                        <i class="fa-solid fa-period text-500"></i>
                                    </div>
                                    <span class="block text-700  text-right">{{ item['createdDate'] | mvsDateFormat }}</span>

                                </div>

                            </div>
                        </div>

                        <div class="flex w-full gap-1 {{!isEditingComment(item) ? 'justify-content-between' : 'justify-content-end'}}">
                              <span *ngIf="!isEditingComment(item)" class="block text-800 line-height-3 max-img"
                                    style="word-break: break-all; white-space: pre-wrap; margin-left: 3rem"
                                    [innerHTML]="item['uiComment'] | mvsSavePipe">
                        </span>
                            <div *ngIf="isEdited(item)"
                                 class="flex align-items-center h-min gap-1 text-500 pr-2">
                                <i class="fa-regular fa-pencil text-xs"></i>
                                <span class="text-sm font-italic"> bearbeitet</span>
                            </div>
                        </div>


                        <div *ngIf="isEditingComment(item)" class="ml-5 mt-2">
                            <mvs-quill-editor
                                    [content]="item['comment']"
                                    [iconLabel]="'Speichern'"
                                    [documentTypeId]="documentTypeId"
                                    [objectIdentifier]="objectIdentifier"
                                    [showCancelButton]="true"
                                    (onSave)="handleUpdateComment($event)"
                                    (onClick)="cancelEdit()"
                            >
                            </mvs-quill-editor>

                        </div>

                    </div>
                    <!--</div>-->
                </ng-container>


                <ng-container
                        *ngIf="item['uiType'] == 'commentEu' && (selectedAction == enumCommentHistory['All Activity'] || selectedAction == enumCommentHistory.Comment)">

                    <!--                                        <div class="flex">-->

                    <!--                                            <mvs-form-control-output-user-image [value]="item['createdBy']"-->
                    <!--                                                                                [displayInfo]="true">-->
                    <!--                                            </mvs-form-control-output-user-image>-->

                    <div [id]="'comment-' + item.id" (contextmenu)="prepareContextMenu($event, item)" class="w-full"
                         (mouseenter)="onCommentHover(item.id)" (mouseleave)="onCommentHover(null)">
                        <div class="grid mx-0">
                                <span class="block text-900 col-6">
                                     <mvs-form-control-output-user-image [value]="item['createdBy']"
                                                                         [displayInfo]="true">
                                     </mvs-form-control-output-user-image>
                                </span>
                            <div class="col-6 align-self-center">
                                <div class="flex gap-2 align-items-center justify-content-end">
                                    <div class="inline-flex align-items-center gap-1 transition-duration-200"
                                         [style.opacity]="hoveredCommentId === item.id ? 1 : 0"
                                         [style.visibility]="hoveredCommentId === item.id ? 'visible' : 'hidden'">
                                        <p-button icon="fa-regular fa-copy"
                                                  (onClick)="copyToClipboard(item)"
                                                  styleClass="p-button-text p-button-sm p-button-rounded"></p-button>
                                    </div>
                                    <div class="flex align-items-center gap-2">
                                        <p-tag class="w-max" icon="pi pi-comment text-primary" value="Eu replied"
                                               styleClass="border-round"
                                               [style]="{background: 'var(--blue-100)' , color: 'var(--blue-700)'}"></p-tag>
                                        <i class="fa-solid fa-period text-500"></i>
                                    </div>
                                    <span class="block text-700  text-right">{{ item['createdDate'] | mvsDateFormat }}</span>
                                </div>

                            </div>
                        </div>

                        <div class="flex w-full justify-content-between gap-1">
                              <span class="block text-800 line-height-3 max-img"
                                    style="word-break: break-all; white-space: pre-wrap; margin-left: 3rem"
                                    [innerHTML]="item['uiComment'] | mvsSavePipe">
                        </span>

                            <div *ngIf="isEdited(item)"
                                 class="flex align-items-center h-min gap-1 text-500 pr-2">
                                <i class="fa-regular fa-pencil text-xs"></i>
                                <span class="text-sm font-italic"> bearbeitet</span>
                            </div>
                        </div>


                    </div>
                    <!--                                        </div>-->
                </ng-container>

                <!--                <ng-container-->
                        <!--                        *ngIf="item['uiType'] == 'visit'">-->
                        <!--                    <div class="w-full">-->
                        <!--                        <div class="grid mx-0">-->
                        <!--                                <span class="block text-900 col-8">-->
                        <!--                                     <mvs-form-control-output-user-image [value]="item['createdBy']"-->
                        <!--                                                                         [displayInfo]="true">-->
                        <!--                                     </mvs-form-control-output-user-image>-->
                        <!--                                </span>-->
                        <!--                            <span class="block text-700 col-4 text-right">{{ item['createdDate'] | mvsDateFormat }}</span>-->
                        <!--                        </div>-->

                        <!--                        <span class="block text-800 line-height-3"-->
                        <!--                              style="word-break: break-all; white-space: pre-wrap; margin-left: 3rem">-->
                        <!--                               visited-->
                        <!--                            </span>-->
                        <!--                    </div>-->
                        <!--                </ng-container>-->

                <ng-container
                        *ngIf="item['uiType'] == 'action' && (selectedAction == enumCommentHistory['All Activity'] || selectedAction == enumCommentHistory.History)">
                    <!--                    <div class="w-full">-->

                    <div class="w-full">
                        <div class="grid mx-0">
                                <span class="block text-900 col-8">
<!--                                    TODO Dependency-->
                                     <mvs-form-control-output-user-image [value]="item['createdBy']"
                                                                         [displayInfo]="true">
                                     </mvs-form-control-output-user-image>
                                </span>
                            <span class="block text-700 col-4 text-right">{{ item['createdDate'] | mvsDateFormat }}</span>
                        </div>

                        <span class="block text-800 line-height-3"
                              style="word-break: break-all; white-space: pre-wrap; margin-left: 3rem">
                               Aktion angelegt
                                <span class="text-primary">{{ item['ticketTypeActionDtoName'] }}</span>
                                 <div class="block text-900 mt-1"
                                      style="word-break: break-all;">{{ item['comment'] }}</div>
                            </span>
                    </div>


                    <!--                        <div class="flex align-items-center gap-3">-->

                    <!--                            <mvs-form-control-output-user-image [value]="item['createdBy']" [displayInfo]="true"></mvs-form-control-output-user-image>-->

                    <!--                            <div class="grid w-full">-->
                    <!--                            <span class="block text-900 col-8">-->
                    <!--&lt;!&ndash;                                <span class="font-medium">{{item['createdBy'] | titlecase}}</span>&ndash;&gt;-->
                    <!--                                    created action:-->
                    <!--                                <span class="text-primary">{{ item['ticketTypeActionDtoName'] }}</span>-->
                    <!--                            </span>-->
                    <!--                                <span class="block text-700 col-4 text-right">{{ item['createdDate'] | mvsDateFormat }}</span>-->
                    <!--                            </div>-->

                    <!--                        </div>-->
                    <!--                        <span-->
                    <!--                                class="block text-900 mt-2"-->
                    <!--                                style="word-break: break-all;">{{ item['comment'] }}</span>-->
                    <!--                    </div>-->
                </ng-container>

                <ng-container
                        *ngIf="item['uiType'] == 'actionStatusChange' && (selectedAction == enumCommentHistory['All Activity'] || selectedAction == enumCommentHistory.History)">
                    <div class="w-full">
                        <div class="grid mx-0">
                            <span class="block text-900 col-8">
                                <mvs-form-control-output-user-image [value]="item['createdBy']"
                                                                    [displayInfo]="true">
                                </mvs-form-control-output-user-image>
                            </span>
                            <span class="block text-700 col-4 text-right">{{ item['createdDate'] | mvsDateFormat }}</span>
                        </div>

                        <span class="block text-800 line-height-3"
                              style="word-break: break-all; margin-left: 3rem">
                            Aktionsstatus geändert
                            <span class="text-primary">{{ item['actionName'] }}</span>:
                            <span class="text-500">{{ getActionStatusLabel(item['previousStatus']) }}</span>
                            <i class="fa-regular fa-arrow-right text-400 mx-1"></i>
                            <span class="font-medium">{{ getActionStatusLabel(item['newStatus']) }}</span>
                        </span>
                    </div>
                </ng-container>

                <ng-container
                        *ngIf="item['uiType'] == 'statusChange' && (selectedAction == enumCommentHistory['All Activity'] || selectedAction == enumCommentHistory.History)">
                    <div class="w-full">
                        <div class="grid mx-0">
                            <span class="block text-900 col-8">
                                <mvs-form-control-output-user-image [value]="item['createdBy']"
                                                                    [displayInfo]="true">
                                </mvs-form-control-output-user-image>
                            </span>
                            <span class="block text-700 col-4 text-right">{{ item['createdDate'] | mvsDateFormat }}</span>
                        </div>

                        <span class="block text-800 line-height-3"
                              style="word-break: break-all; margin-left: 3rem">
                            Ticketstatus geändert:
                            <span class="text-500">{{ getTicketStatusLabel(item['previousStatus']) }}</span>
                            <i class="fa-regular fa-arrow-right text-400 mx-1"></i>
                            <span class="font-medium">{{ getTicketStatusLabel(item['newStatus']) }}</span>
                        </span>
                    </div>
                </ng-container>
            }

        </div>
    </ng-container>

    <p-contextMenu #cm1 appendTo="body"
                   *ngIf="contextMenuItems && contextMenuItems.length"
                   [model]="contextMenuItems"
                   (onHide)="handleContextMenuHide()"
    >
    </p-contextMenu>

</ng-container>
